'use client';
import React from 'react';

import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';

import Error from '@components/views/error/ErrorPage';
import Spinner from '@uikit/spinner';

import { SpinnerContainer } from './styled';

const getDynamicComponent = (c: string) =>
  dynamic(
    () => import(`@page/online-transactions/${c}`).catch(() => () => <Error />),
    {
      ssr: false,
      loading: () => (
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      ),
    }
  );

const OnlineTransactions = () => {
  const params = useParams();
  const ActiveOnlineTransactionPage = getDynamicComponent(
    params?.slug as string
  );

  return (
    <>
      <ActiveOnlineTransactionPage />
    </>
  );
};

export default OnlineTransactions;
